"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6296],{

/***/ 20664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Errors; },
  "z": function() { return /* binding */ pollAsync; }
});

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(27532);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(11204);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(97912);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(21582);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(5726);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(73588);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(80460);
;// CONCATENATED MODULE: ../../../../libraries/src/errors/custom-error.ts





var CustomError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(CustomError, Error1);
    var _super = (0,_create_super/* default */.Z)(CustomError);
    function CustomError(message, data) {
        (0,_class_call_check/* default */.Z)(this, CustomError);
        var _this;
        _this = _super.call(this, message);
        _this.data = data;
        _this.name = _this.constructor.name;
        // Only available in Chrome and Node.js
        if ("captureStackTrace" in Error) {
            Error.captureStackTrace((0,_assert_this_initialized/* default */.Z)(_this), _this.constructor);
        }
        return _this;
    }
    return CustomError;
}((0,_wrap_native_super/* default */.Z)(Error));

;// CONCATENATED MODULE: ../../../../libraries/src/errors/bad-request-error.ts




var BadRequestError = /*#__PURE__*/ function(CustomError) {
    "use strict";
    (0,_inherits/* default */.Z)(BadRequestError, CustomError);
    var _super = (0,_create_super/* default */.Z)(BadRequestError);
    function BadRequestError(message) {
        var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0,_class_call_check/* default */.Z)(this, BadRequestError);
        var _this;
        _this = _super.call(this, message, data);
        _this.name = "BadRequestError";
        _this.message = message;
        _this.statusCode = 400;
        return _this;
    }
    return BadRequestError;
}(CustomError);

// EXTERNAL MODULE: ../../../../libraries/src/language-helpers/promises/sleep.ts
var sleep = __webpack_require__(66042);
;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/promises/poll.ts









/**
 * pollAsync
 *
 * fn: () -> Promise<PollResult> { stopPolling: bool, result: any }
 * delay: (polledTimes: int) -> millisecondsToSleep: int
 * timeout: int
 *
 * pollAsync is current used in OnSuccessfulPayment
 * while poll is used in frontend checkout polling.
 * Due to this I don't want to merge this atm for risk
 * of a subtle breakage. So instead this is being left here
 * as the latest version to use
 */ var PollingTimeoutError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(PollingTimeoutError, Error1);
    var _super = (0,_create_super/* default */.Z)(PollingTimeoutError);
    function PollingTimeoutError(message) {
        var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0,_class_call_check/* default */.Z)(this, PollingTimeoutError);
        var _this;
        _this = _super.call(this, message);
        _this.name = _this.constructor.name;
        _this.data = data;
        if ("captureStackTrace" in Error) {
            // Only V8 (Chrome, Node) supports this
            Error.captureStackTrace((0,_assert_this_initialized/* default */.Z)(_this), _this.constructor);
        }
        return _this;
    }
    return PollingTimeoutError;
}((0,_wrap_native_super/* default */.Z)(Error));
var Errors = {
    PollingTimeoutError: PollingTimeoutError
};
function pollAsync(fn, delay, timeout) {
    return _pollAsync.apply(this, arguments);
}
function _pollAsync() {
    _pollAsync = (0,_async_to_generator/* default */.Z)(function(fn, delay, timeout) {
        var startTime;
        function p(polledTimes) {
            return _p.apply(this, arguments);
        }
        function _p() {
            _p = (0,_async_to_generator/* default */.Z)(function(polledTimes) {
                var timeSpent, pollResult;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            timeSpent = Date.now() - startTime;
                            if (timeSpent >= timeout) {
                                throw new PollingTimeoutError("Timeout");
                            }
                            return [
                                4,
                                fn(timeSpent)
                            ];
                        case 1:
                            pollResult = _state.sent() || {};
                            if (pollResult.stopPolling) {
                                return [
                                    2,
                                    pollResult.result
                                ];
                            }
                            return [
                                4,
                                (0,sleep/* sleep */._)(delay(polledTimes))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                p(polledTimes + 1)
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return _p.apply(this, arguments);
        }
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!fn || typeof fn !== "function") {
                        throw new BadRequestError("fn is required for pollAsync");
                    }
                    if (!delay || typeof delay !== "function") {
                        throw new BadRequestError("delay is required for pollAsync");
                    }
                    if (!timeout || typeof timeout !== "number") {
                        throw new BadRequestError("number is required for pollAsync");
                    }
                    startTime = Date.now();
                    return [
                        4,
                        p(0)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _pollAsync.apply(this, arguments);
}


/***/ }),

/***/ 66042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ sleep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11204);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80460);


function sleep(ms) {
    return _sleep.apply(this, arguments);
}
function _sleep() {
    _sleep = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(ms) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new Promise(function(resolve) {
                            setTimeout(function() {
                                resolve();
                            }, ms);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _sleep.apply(this, arguments);
}


/***/ }),

/***/ 46296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$U": function() { return /* binding */ stopPaying; },
/* harmony export */   "CN": function() { return /* binding */ addDiscountCodeToCheckout; },
/* harmony export */   "N8": function() { return /* binding */ CustomTimeoutError; },
/* harmony export */   "Ow": function() { return /* binding */ setCheckoutPaying; },
/* harmony export */   "PB": function() { return /* binding */ getAddToPreorderView; },
/* harmony export */   "PL": function() { return /* binding */ fetchCheckout; },
/* harmony export */   "Pf": function() { return /* binding */ removeGiftCardPaymentFromCheckout; },
/* harmony export */   "Q$": function() { return /* binding */ setCheckoutOpen; },
/* harmony export */   "QM": function() { return /* binding */ CheckoutStateError; },
/* harmony export */   "RZ": function() { return /* binding */ ERROR_MESSAGES; },
/* harmony export */   "Y_": function() { return /* binding */ preferOriginalShipDate; },
/* harmony export */   "h_": function() { return /* binding */ confirmShippingOptions; },
/* harmony export */   "jn": function() { return /* binding */ waitForCheckoutCompleted; },
/* harmony export */   "oZ": function() { return /* binding */ updateInformation; },
/* harmony export */   "pw": function() { return /* binding */ removeItemFromCheckout; },
/* harmony export */   "uF": function() { return /* binding */ removeDiscountCodeFromCheckout; },
/* harmony export */   "x$": function() { return /* binding */ setShippingGroupOptions; }
/* harmony export */ });
/* unused harmony exports createCheckout, addItemToCheckout, fetchAvailableShippingRates, fetchShippingOptions */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11204);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97912);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21582);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17211);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40891);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61866);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9469);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9334);
/* harmony import */ var _swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5726);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73588);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80460);
/* harmony import */ var _purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81563);
/* harmony import */ var _purple_dot_libraries_src_language_helpers_promises_poll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20664);













var ERROR_MESSAGES = {
    CHECKOUT_SOLD_OUT: "We're sorry, this product sold out while we were processing your order. Any payment taken has been refunded",
    CHECKOUT_EXPIRED: "This checkout session has expired",
    CHECKOUT_UNEXPECTED_ERROR: "We're sorry, an unexpected error occured while processing your order. Any payment taken has been refunded. Please refresh the page to try again or contact customer support.",
    CHECKOUT_TIMEOUT: "Please check your email for your order confirmation. If it doesn't arrive in the next few minutes, please contact customer support to check the status of your order.",
    PAYMENT_METHOD_MISMATCH: "Please use the same card details as the original preorder",
    TOO_MANY_PAYING: "Oops! A few too many people are trying to checkout. Please try again in 1 minute.",
    SHIPPING_GROUPS_TIMEOUT: "We encountered a problem whilst calculating your shipping rate. Please try again.",
    UNKNOWN_ERROR: "We're sorry, it looks like something has gone wrong with your request, please try again"
};
var CheckoutStateError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(CheckoutStateError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CheckoutStateError);
    function CheckoutStateError(message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CheckoutStateError);
        var _this;
        _this = _super.call(this, message);
        _this.data = {
            isUserRetryable: false
        };
        _this.originalMessage = message;
        _this.responseSucceeded = true;
        return _this;
    }
    return CheckoutStateError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
var CustomTimeoutError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(CustomTimeoutError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(CustomTimeoutError);
    function CustomTimeoutError(message) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, CustomTimeoutError);
        var _this;
        _this = _super.call(this, message !== null && message !== void 0 ? message : ERROR_MESSAGES.CHECKOUT_TIMEOUT);
        _this.data = {
            isUserRetryable: false
        };
        _this.originalMessage = ERROR_MESSAGES.CHECKOUT_TIMEOUT;
        return _this;
    }
    return CustomTimeoutError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Error));
function createCheckout(_) {
    return _createCheckout.apply(this, arguments);
}
function _createCheckout() {
    _createCheckout = _async_to_generator(function(param) {
        var _param, ref, storeId, skuId, presaleId, releaseId, lineItemProperties, userSessionToken, result, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], storeId = ref.storeId, skuId = ref.skuId, presaleId = ref.presaleId, releaseId = ref.releaseId, lineItemProperties = ref.lineItemProperties, userSessionToken = ref.userSessionToken;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/create", {
                            storeId: storeId,
                            skuId: skuId,
                            presaleId: presaleId,
                            releaseId: releaseId,
                            lineItemProperties: lineItemProperties,
                            userSessionToken: userSessionToken
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _createCheckout.apply(this, arguments);
}
/**
 * Updates the checkout information.
 *
 * @param {Object[]} params - The parameters for updating the checkout information.
 * @param {string} params[].checkoutId - The ID of the checkout.
 * @param {string} params[].email - The email address of the customer.
 * @param {boolean} [params[].consentedToEmailMarketing] - Whether the customer consented to email marketing.
 * @param {boolean} [params[].consentedToSmsMarketing] - Whether the customer consented to SMS marketing.
 * @param {Object} params[].shippingAddress - The shipping address of the customer.
 * @param {boolean} params[].isPrefill - Whether the information is prefilled.
 * @returns {Promise<Object>} The result data from the API.
 * @throws Will throw an error if the request fails.
 */ function updateInformation(_) {
    return _updateInformation.apply(this, arguments);
}
function _updateInformation() {
    _updateInformation = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, email, consentedToEmailMarketing, consentedToSmsMarketing, shippingAddress, isPrefill, result, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, email = ref.email, consentedToEmailMarketing = ref.consentedToEmailMarketing, consentedToSmsMarketing = ref.consentedToSmsMarketing, shippingAddress = ref.shippingAddress, isPrefill = ref.isPrefill;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/".concat(checkoutId), {
                            email: email,
                            consentedToEmailMarketing: consentedToEmailMarketing,
                            consentedToSmsMarketing: consentedToSmsMarketing,
                            shippingAddress: shippingAddress,
                            isPrefill: isPrefill,
                            clientTimestamp: Date.now()
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _updateInformation.apply(this, arguments);
}
function confirmShippingOptions(_) {
    return _confirmShippingOptions.apply(this, arguments);
}
function _confirmShippingOptions() {
    _confirmShippingOptions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, selectedRates, preorderShippingOptionId, result, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, selectedRates = ref.selectedRates, preorderShippingOptionId = ref.preorderShippingOptionId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/confirm-shipping-options", {
                            checkoutId: checkoutId,
                            selectedRates: selectedRates,
                            preorderShippingOptionId: preorderShippingOptionId
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _confirmShippingOptions.apply(this, arguments);
}
function preferOriginalShipDate(_) {
    return _preferOriginalShipDate.apply(this, arguments);
}
function _preferOriginalShipDate() {
    _preferOriginalShipDate = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, preferOriginalShipDate, result, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, preferOriginalShipDate = ref.preferOriginalShipDate;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/prefer-original-ship-date", {
                            checkoutId: checkoutId,
                            preferOriginalShipDate: preferOriginalShipDate
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _preferOriginalShipDate.apply(this, arguments);
}
/**
 * @returns {Promise<ReturnType<typeof import('../../../../core/checkouts/use-cases/set-pre-order-checkout-to-paying').SetPreorderCheckoutToPaying>>}
 */ function setCheckoutPaying(_) {
    return _setCheckoutPaying.apply(this, arguments);
}
function _setCheckoutPaying() {
    _setCheckoutPaying = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, paymentMethodType, result, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, paymentMethodType = ref.paymentMethodType;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/set-paying", {
                            checkoutId: checkoutId,
                            paymentMethodType: paymentMethodType
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    if (err.statusCode === 503 || err.statusCode === 429) {
                        err.originalMessage = ERROR_MESSAGES.TOO_MANY_PAYING;
                        throw err;
                    }
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _setCheckoutPaying.apply(this, arguments);
}
function setCheckoutOpen(_) {
    return _setCheckoutOpen.apply(this, arguments);
}
function _setCheckoutOpen() {
    _setCheckoutOpen = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, checkoutId, result, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), checkoutId = _param[0].checkoutId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/set-open", {
                            checkoutId: checkoutId
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _setCheckoutOpen.apply(this, arguments);
}
function stopPaying(_) {
    return _stopPaying.apply(this, arguments);
}
function _stopPaying() {
    _stopPaying = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, checkoutId, result, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), checkoutId = _param[0].checkoutId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/stop-paying", {
                            checkoutId: checkoutId
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _stopPaying.apply(this, arguments);
}
function fetchCheckout(_) {
    return _fetchCheckout.apply(this, arguments);
}
function _fetchCheckout() {
    _fetchCheckout = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, checkoutId, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), checkoutId = _param[0].checkoutId;
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .fetchJSON */ .ZV)("/embedded-checkout/pre-order-checkouts/".concat(checkoutId))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _fetchCheckout.apply(this, arguments);
}
function fetchCheckoutState(_) {
    return _fetchCheckoutState.apply(this, arguments);
}
function _fetchCheckoutState() {
    _fetchCheckoutState = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var checkoutId, addToPreorderCheckout, checkout, preorderCompleted, inStockCompleted, paymentCompleted, state;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    checkoutId = param.checkoutId, addToPreorderCheckout = param.addToPreorderCheckout;
                    return [
                        4,
                        fetchCheckout([
                            {
                                checkoutId: checkoutId
                            }
                        ])
                    ];
                case 1:
                    checkout = _state.sent();
                    preorderCompleted = !!checkout.preorder;
                    inStockCompleted = !checkout.hasRegularLineItems || !!checkout.order;
                    paymentCompleted = checkout.paymentCompleted;
                    state = checkout.state;
                    // Don't consider the checkout complete until both orders have been completed
                    if ((state === "PAYING" || state === "COMPLETED") && paymentCompleted && !inStockCompleted && !addToPreorderCheckout) {
                        state = "RECEIVED";
                    }
                    return [
                        2,
                        {
                            state: state,
                            error: checkout.error,
                            preorderCompleted: preorderCompleted,
                            inStockCompleted: inStockCompleted,
                            paymentCompleted: paymentCompleted
                        }
                    ];
            }
        });
    });
    return _fetchCheckoutState.apply(this, arguments);
}
var SIX_MINUTES = 360000;
var TWENTY_SECONDS = 20000;
function waitForCheckoutCompleted(_) {
    return _waitForCheckoutCompleted.apply(this, arguments);
}
function _waitForCheckoutCompleted() {
    _waitForCheckoutCompleted = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var checkoutId, _completedTimeout, completedTimeout, _receivedTimeout, receivedTimeout, _addToPreorderCheckout, addToPreorderCheckout, result, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    checkoutId = param.checkoutId, _completedTimeout = param.completedTimeout, completedTimeout = _completedTimeout === void 0 ? SIX_MINUTES : _completedTimeout, _receivedTimeout = param.receivedTimeout, receivedTimeout = _receivedTimeout === void 0 ? TWENTY_SECONDS : _receivedTimeout, _addToPreorderCheckout = param.addToPreorderCheckout, addToPreorderCheckout = _addToPreorderCheckout === void 0 ? false : _addToPreorderCheckout;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_language_helpers_promises_poll__WEBPACK_IMPORTED_MODULE_0__/* .pollAsync */ .z)(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(timeSpent) {
                                var _ref, state, error, completed, data, data1, err;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                6,
                                                ,
                                                7
                                            ]);
                                            return [
                                                4,
                                                fetchCheckoutState({
                                                    checkoutId: checkoutId,
                                                    addToPreorderCheckout: addToPreorderCheckout
                                                })
                                            ];
                                        case 1:
                                            _ref = _state.sent(), state = _ref.state, error = _ref.error, completed = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref, [
                                                "state",
                                                "error"
                                            ]);
                                            if (!(state === "RECEIVED" && receivedTimeout >= 0 && timeSpent > receivedTimeout)) return [
                                                3,
                                                3
                                            ];
                                            return [
                                                4,
                                                fetchCheckout([
                                                    {
                                                        checkoutId: checkoutId
                                                    }
                                                ])
                                            ];
                                        case 2:
                                            data = _state.sent();
                                            return [
                                                2,
                                                {
                                                    stopPolling: true,
                                                    result: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, data), {
                                                        state: state
                                                    }), completed)
                                                }
                                            ];
                                        case 3:
                                            if (error === "PAYMENT_METHOD_MISMATCH") {
                                                throw new CheckoutStateError(ERROR_MESSAGES.PAYMENT_METHOD_MISMATCH);
                                            }
                                            if (state === "PAYING" || state === "RECEIVED") {
                                                return [
                                                    2,
                                                    {
                                                        stopPolling: false
                                                    }
                                                ];
                                            }
                                            if (!(state === "COMPLETED" || state === "OPEN")) return [
                                                3,
                                                5
                                            ];
                                            return [
                                                4,
                                                fetchCheckout([
                                                    {
                                                        checkoutId: checkoutId
                                                    }
                                                ])
                                            ];
                                        case 4:
                                            data1 = _state.sent();
                                            return [
                                                2,
                                                {
                                                    stopPolling: true,
                                                    result: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, data1, completed)
                                                }
                                            ];
                                        case 5:
                                            if (state === "SOLD_OUT") {
                                                throw new CheckoutStateError(ERROR_MESSAGES.CHECKOUT_SOLD_OUT);
                                            }
                                            if (state === "EXPIRED") {
                                                throw new CheckoutStateError(ERROR_MESSAGES.CHECKOUT_EXPIRED);
                                            }
                                            // state === ERROR
                                            throw new CheckoutStateError(ERROR_MESSAGES.CHECKOUT_UNEXPECTED_ERROR);
                                        case 6:
                                            err = _state.sent();
                                            // Keep polling if there's a network error
                                            if (!err.responseSucceeded) {
                                                return [
                                                    2,
                                                    {
                                                        stopPolling: false,
                                                        result: false
                                                    }
                                                ];
                                            }
                                            throw withDefaultedUnknownMessage(err);
                                        case 7:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(timeSpent) {
                                return _ref.apply(this, arguments);
                            };
                        }(), function(polledTimes) {
                            // After ~2 minutes
                            if (polledTimes > 30) {
                                return 10000;
                            }
                            // After ~45 seconds
                            if (polledTimes > 15) {
                                return 5000;
                            }
                            // After ~20 seconds
                            if (polledTimes > 10) {
                                return 3000;
                            }
                            // After ~4 seconds
                            if (polledTimes > 5) {
                                return 1500;
                            }
                            return 750;
                        }, completedTimeout)
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 3:
                    err = _state.sent();
                    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(err, _purple_dot_libraries_src_language_helpers_promises_poll__WEBPACK_IMPORTED_MODULE_0__/* .Errors.PollingTimeoutError */ .D.PollingTimeoutError)) {
                        throw new CustomTimeoutError();
                    }
                    throw err;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _waitForCheckoutCompleted.apply(this, arguments);
}
function addItemToCheckout(_) {
    return _addItemToCheckout.apply(this, arguments);
}
function _addItemToCheckout() {
    _addItemToCheckout = _async_to_generator(function(param) {
        var _param, ref, checkoutId, skuId, presaleId, releaseId, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), ref = _param[0], checkoutId = ref.checkoutId, skuId = ref.skuId, presaleId = ref.presaleId, releaseId = ref.releaseId;
                    return [
                        4,
                        postJSON("/embedded-checkout/pre-order-checkouts/add", {
                            checkoutId: checkoutId,
                            skuId: skuId,
                            presaleId: presaleId,
                            releaseId: releaseId
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _addItemToCheckout.apply(this, arguments);
}
function removeItemFromCheckout(_) {
    return _removeItemFromCheckout.apply(this, arguments);
}
function _removeItemFromCheckout() {
    _removeItemFromCheckout = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, lineItemId, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, lineItemId = ref.lineItemId;
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/remove", {
                            checkoutId: checkoutId,
                            lineItemId: lineItemId
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _removeItemFromCheckout.apply(this, arguments);
}
function addDiscountCodeToCheckout(_) {
    return _addDiscountCodeToCheckout.apply(this, arguments);
}
function _addDiscountCodeToCheckout() {
    _addDiscountCodeToCheckout = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, code, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, code = ref.code;
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/add-discount-code", {
                            checkoutId: checkoutId,
                            code: code
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _addDiscountCodeToCheckout.apply(this, arguments);
}
function getAddToPreorderView(_) {
    return _getAddToPreorderView.apply(this, arguments);
}
function _getAddToPreorderView() {
    _getAddToPreorderView = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, checkoutId, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), checkoutId = _param[0].checkoutId;
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .fetchJSON */ .ZV)("/embedded-checkout/add-to-preorder/view?checkoutId=".concat(checkoutId))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _getAddToPreorderView.apply(this, arguments);
}
function removeDiscountCodeFromCheckout(_) {
    return _removeDiscountCodeFromCheckout.apply(this, arguments);
}
function _removeDiscountCodeFromCheckout() {
    _removeDiscountCodeFromCheckout = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, discountApplicationId, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, discountApplicationId = ref.discountApplicationId;
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/remove-discount-code", {
                            checkoutId: checkoutId,
                            discountApplicationId: discountApplicationId
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _removeDiscountCodeFromCheckout.apply(this, arguments);
}
function removeGiftCardPaymentFromCheckout(_) {
    return _removeGiftCardPaymentFromCheckout.apply(this, arguments);
}
function _removeGiftCardPaymentFromCheckout() {
    _removeGiftCardPaymentFromCheckout = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var _param, ref, checkoutId, paymentIntentId, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), ref = _param[0], checkoutId = ref.checkoutId, paymentIntentId = ref.paymentIntentId;
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/remove-gift-card-payment", {
                            checkoutId: checkoutId,
                            paymentIntentId: paymentIntentId
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _removeGiftCardPaymentFromCheckout.apply(this, arguments);
}
function fetchAvailableShippingRates(_) {
    return _fetchAvailableShippingRates.apply(this, arguments);
}
function _fetchAvailableShippingRates() {
    _fetchAvailableShippingRates = _async_to_generator(function(param) {
        var _param, checkoutId, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    return [
                        4,
                        fetchJSON("/embedded-checkout/pre-order-checkouts/".concat(checkoutId, "/shipping-rates"))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _fetchAvailableShippingRates.apply(this, arguments);
}
function fetchShippingOptions(_) {
    return _fetchShippingOptions.apply(this, arguments);
}
function _fetchShippingOptions() {
    _fetchShippingOptions = _async_to_generator(function(param) {
        var _param, checkoutId, result, err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param = _sliced_to_array(param, 1), checkoutId = _param[0].checkoutId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchJSON("/embedded-checkout/pre-order-checkouts/".concat(checkoutId, "/shipping-group-options"))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
                case 3:
                    err = _state.sent();
                    if (err.statusCode === 503 || err.statusCode === 429) {
                        throw new CheckoutStateError(ERROR_MESSAGES.SHIPPING_GROUPS_TIMEOUT);
                    }
                    throw withDefaultedUnknownMessage(err);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchShippingOptions.apply(this, arguments);
}
function setShippingGroupOptions(_) {
    return _setShippingGroupOptions.apply(this, arguments);
}
function _setShippingGroupOptions() {
    _setShippingGroupOptions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var checkoutId, option, selectedShippingGroupRates, confirm, preferOriginalShipDate, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    checkoutId = param.checkoutId, option = param.option, selectedShippingGroupRates = param.selectedShippingGroupRates, confirm = param.confirm, preferOriginalShipDate = param.preferOriginalShipDate;
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_8__/* .postJSON */ .ty)("/embedded-checkout/pre-order-checkouts/".concat(checkoutId, "/shipping-group-options"), {
                            option: option,
                            confirm: confirm,
                            selectedShippingRates: selectedShippingGroupRates && Object.entries(selectedShippingGroupRates).map(function(param) {
                                var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 2), shippingGroupId = _param[0], rateId = _param[1];
                                return {
                                    shippingGroupId: shippingGroupId,
                                    rateId: rateId
                                };
                            }),
                            clientTimestampMs: Date.now(),
                            preferOriginalShipDate: preferOriginalShipDate
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return _setShippingGroupOptions.apply(this, arguments);
}
function withDefaultedUnknownMessage(err) {
    err.originalMessage = err.originalMessage || ERROR_MESSAGES.UNKNOWN_ERROR;
    return err;
}


/***/ })

}]);